<template>
  <v-alert
    v-if="summary"
    id="tmc-import-run-status"
    :type="summary.type"
    dense
    text
    class="mb-4"
  >
    {{ summary.message }}
  </v-alert>
  <v-alert
    v-else-if="checkFailed"
    id="tmc-import-run-status"
    type="warning"
    dense
    text
    class="mb-4"
  >
    Could not check whether the import has finished. Trying again...
  </v-alert>
</template>

<script>
import { mapActions } from 'vuex';
import { importRunSummary } from '../../views/bulk/import.utils';

const POLL_MS = 3000;

// Says whether a staged import (paid vouchers, paid warrants) is complete, and keeps asking while it
// is not. The results screen under it must not offer Mark Paid on anything but a complete import:
// the rows it lists are whatever the stream has staged so far.
//
// Emits `change` with the run marker whenever it is known: an object while a marker exists, null for
// an import from before markers existed (nothing to wait for). It does not emit while the status
// cannot be read, so the parent keeps treating the run as not yet complete.
export default {
  name: 'ImportRunStatusBanner',
  props: {
    chunkID: { type: String, default: '' },
    // used only when there is no chunkID, to find the latest run of this kind of import
    destination: { type: String, default: '' },
    pollMs: { type: Number, default: POLL_MS },
  },
  data: () => ({
    run: undefined,
    checkFailed: false,
    timer: null,
    gone: false,
  }),
  computed: {
    summary() {
      return importRunSummary(this.run);
    },
  },
  created() {
    this.refresh();
  },
  beforeDestroy() {
    this.gone = true;
    clearTimeout(this.timer);
  },
  methods: {
    ...mapActions('Bulk', ['loadImportRunStatus']),
    async refresh() {
      const run = await this.loadImportRunStatus({
        chunkID: this.chunkID,
        destination: this.destination,
      });
      if (this.gone) {
        return;
      }
      this.checkFailed = run === undefined;
      if (run !== undefined) {
        this.run = run;
        this.$emit('change', run);
      }
      // keep asking until the run is settled, or while the answer could not be read
      if (run === undefined || (run && run.status === 'importing')) {
        this.timer = setTimeout(this.refresh, this.pollMs);
      }
    },
  },
};
</script>
